import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Visible } from './visible';

class NavbarBase extends Component {
  render() {
    const { showResearch, showCV } = this.props;

    return (
      <nav>
        <ul className="nav nav-tabs nav-justified">
          <li>
            <NavLink exact to="/">
              Home
            </NavLink>
          </li>

          <Visible modes={(m) => m > 0 || showResearch}>
            <li>
              <NavLink to="/research">Research</NavLink>
            </li>
          </Visible>

          <Visible modes={(m) => m > 0 || showCV}>
            <li>
              <NavLink to="/cv">CV</NavLink>
            </li>
          </Visible>

          <li>
            <NavLink to="/contact">Contact</NavLink>
          </li>
        </ul>
      </nav>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    showCV: state.cv && !!state.cv.displayable,
    showResearch: !!state.works && !!state.works.length,
  };
};

export const Navbar = withRouter(connect(mapStateToProps)(NavbarBase));
